module.exports = __webpack_public_path__ + "static/favicon-36e47e74810a0d8c32a77f495c49cf8e.ico";